import { ResponseCode } from "@app/constants/Common";
import { alertMessage, showMessage } from "@app/constants/Messages";
import { pipelineOptionsToString, pipelineStringToOptions } from "@pages/dvtjcuv/common/PipelineUtil";
import InputDiscussionWCddAcquireContent from '@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputDiscussionWCddAcquireContent';
import { requestSaveDVTJCUVPipeline } from '@pages/dvtjcuv/service/DVTJCUVPipelineService';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

const InputDiscussionWCddAcquireModal = (props) => {
    const [pipeline, setPipeline] = useState({});

    const {pipelineInfo, mode, isShow, onClose} = props

    const setPipelineInfoForDisplay = (inputPipeline) => {
        setPipeline(pipelineStringToOptions(inputPipeline))
    }

    useEffect(() => {
        if (pipelineInfo) {
            const pp = {...pipelineInfo}
            pp.id = ""
            setPipelineInfoForDisplay(pp)
        } else {
            setPipeline({})
        }
    }, [isShow, pipelineInfo]);

    const onUpdatePipeLineInfo = () => {
        // Validate
        if (!pipeline.cdd_id) {
            showMessage("Vui lòng nhập Cdd ID")
            return;
        }

        const body = pipelineOptionsToString(pipeline)
        requestSaveDVTJCUVPipeline(body).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose(res.sts_code === ResponseCode.SUCCESS)
            } else {
                alertMessage(res.sts_code)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        })
    }

    const onChangeInputItem = (values, column) => {
        pipeline[column.key] = values
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen style={{zIndex: 3002}}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {'Discussion w Cdd (Acquire)'}
                    </Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <form onSubmit={(event) => {
                    event.preventDefault();
                    onUpdatePipeLineInfo()
                }}>
                <Modal.Body>
                    <InputDiscussionWCddAcquireContent
                        onChangeInputItem={onChangeInputItem} pipeLineInfo={pipeline}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button type='submit'
                            className='btn btn-primary'
                            // isLoading={isLoading}
                            // disabled={isLoading}
                            // onClick={() => {
                            //     onUpdatePipeLineInfo()
                            // }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default InputDiscussionWCddAcquireModal;
